import axios from 'axios';
import { config } from '../config';

const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  const headers: Record<string, string> = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest',
  };

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  } else {
    headers['x-api-key'] = config.API_KEY || '';
  }

  return headers;
};

export interface InventoryUploadGroup {
  claim_id: number;
  claim_number: string;
  facility_id: string | null;
  status: string;
  status_label: string;
  tenant_name: string;
  upload_count: number;
  latest_upload_at: string;
}

export interface InventoryUploadsDashboard {
  new_count: number;
  groups: InventoryUploadGroup[];
}

export const getInventoryUploadsDashboard = async (): Promise<InventoryUploadsDashboard> => {
  const response = await axios.get(`${config.API_URL}/inventory-uploads`, {
    headers: getAuthHeaders(),
  });
  return response.data;
};

export const ackInventoryUploadsForClaim = async (
  claimId: string | number
): Promise<{ acknowledged: number }> => {
  const response = await axios.post(
    `${config.API_URL}/claims/${claimId}/inventory-uploads/ack`,
    {},
    { headers: getAuthHeaders() }
  );
  return response.data;
};
